import {Section} from "../grouping/Section";
import {useAmodels} from "../../api/amodelsapi";
import {useBmodels} from "../../api/bmodelsapi";
import {useCmodels} from "../../api/cmodelsapi";
import {useDmodels} from "../../api/dmodelsapi";
import {useOccActimodels} from "../../api/occactimodelsapi";
import {Col, FormControl, FormLabel} from "react-bootstrap";
import {ButtonCustom} from "../calendar/components/ButtonCustom";
import {useCallback, useMemo, useState} from "react";
import {DataListView} from "../grouping/DataListView";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {AmodelForm} from "../forms/AmodelForm";
import {BmodelForm} from "../forms/BmodelForm";
import {CmodelForm} from "../forms/CmodelForm";
import {DmodelForm} from "../forms/DmodelForm";
import {OccActimodelForm} from "../forms/OccActimodelForm";

export function FormslOption(props) {
    const {title} = props;
    const {amodels} = useAmodels();
    const {bmodels} = useBmodels();
    const {cmodels} = useCmodels();
    const {dmodels} = useDmodels();
    const {occactimodels} = useOccActimodels();


    return <Section title={title}>
        <Selector amodels={amodels}
                  bmodels={bmodels}
                  cmodels={cmodels}
                  dmodels={dmodels}
                  occactimodels={occactimodels}
        />
    </Section>
}

function selectHeader(formname) {
    switch (formname) {
        case 'amodels': {
            return [{title: 'naam', fieldName: 'naam'}, {title: 'voornaam', fieldName: 'voornaam'}, {
                title: 'reden',
                fieldName: 'optie'
            }, {title: 'datum', fieldName: 'opstellingDatum'}]
        }
        case 'bmodels': {
            return [{title: 'club', fieldName: 'club'}, {title: 'adres', fieldName: 'adres'}, {
                title: 'sector',
                fieldName: 'sector'
            }, {title: 'stamnr', fieldName: 'stamnr'},]
        }
        case 'cmodels': {
            return [{title: 'sector', fieldName: 'sector'}, {title: 'sectorNr', fieldName: 'sectornr'}, {
                title: 'datum',
                fieldName: 'datumOpstelling'
            }]
        }
        case 'dmodels': {
            return [{title: 'naam', fieldName: 'naamVoorzitter'}, {
                title: 'voornaam',
                fieldName: 'voornaamVoorzitter'
            }, {title: 'provincie', fieldName: 'provincie'}]
        }
        case 'occacti': {
            return [{title: 'club', fieldName: 'club'}, {
                title: 'locatie',
                fieldName: 'locatieActiv'
            }, {title: 'Datum activiteit', fieldName: 'datumActiv'}]
        }
    }

}

function Selector(props) {
    const {
        amodels,
        bmodels,
        cmodels,
        dmodels,
        occactimodels
    } = props;
    const [open, setOpen] = useState(false);
    const [itemEditing, setItemEditing] = useState(undefined);
    const [selectedFormType, setSelectedFormType] = useState('amodels');
    const [selectedDataListHeader, setSelectedDataListHeader] = useState(selectHeader(selectedFormType));
    const amodelsNotprocessed = amodels ? amodels?.filter(a => a.verwerkt === false).length : '';
    const bmodelsNotprocessed = bmodels ? bmodels?.filter(a => a.verwerkt === false).length : '';
    const cmodelsNotprocessed = cmodels ? cmodels?.filter(a => a.verwerkt === false).length : '';
    const dmodelsNotprocessed = dmodels ? dmodels?.filter(a => a.verwerkt === false).length : '';
    const occactiNotprocessed = occactimodels ? occactimodels?.filter(a => a.verwerkt === false).length : ''

    const selectedForms =
        selectedFormType === 'amodels' ? amodels :
            selectedFormType === 'bmodels' ? bmodels :
                selectedFormType === 'cmodels' ? cmodels :
                    selectedFormType === 'dmodels' ? dmodels :
                        selectedFormType === 'occacti' ? occactimodels : []
    return <Section>
        <Col xs={'auto'} className={'pe-1'}>
            <ButtonCustom onClick={() => {
                setSelectedDataListHeader(selectHeader('amodels'));
                setSelectedFormType('amodels');

            }} title={`Amodels ${amodelsNotprocessed}`}></ButtonCustom>
        </Col>
        <Col xs={'auto'} className={'pe-1'}>
            <ButtonCustom onClick={() => {
                setSelectedDataListHeader(selectHeader('bmodels'));
                setSelectedFormType('bmodels');

            }} title={`Bmodels ${bmodelsNotprocessed}`}></ButtonCustom>
        </Col>
        <Col xs={'auto'} className={'pe-1'}>
            <ButtonCustom onClick={() => {
                setSelectedDataListHeader(selectHeader('cmodels'));
                setSelectedFormType('cmodels');

            }} title={`Cmodels ${cmodelsNotprocessed}`}></ButtonCustom>
        </Col>
        <Col xs={'auto'} className={'pe-1'}>
            <ButtonCustom onClick={() => {
                setSelectedDataListHeader(selectHeader('dmodels'));
                setSelectedFormType('dmodels');

            }} title={`Dmodels ${dmodelsNotprocessed}`}></ButtonCustom>
        </Col>
        <Col xs={'auto'} className={'pe-1'}>
            <ButtonCustom onClick={() => {
                setSelectedDataListHeader(selectHeader('occacti'));
                setSelectedFormType('occacti');

            }}
                          title={`OccActi ${occactiNotprocessed}`}></ButtonCustom>
        </Col>
        <TestingState selectedForms={selectedForms}
                      itemEditing={itemEditing}
                      selectedFormType={selectedFormType}
                      onItemEditingChange={setItemEditing}
                      open={open} onOpenChanged={setOpen} selectedDataListHeader={selectedDataListHeader}/>
    </Section>
}

function TestingState(props) {
    const {
        itemEditing,
        onItemEditingChange,
        onOpenChanged,
        open,
        selectedForms,
        selectedFormType,
        selectedDataListHeader
    } = props;
    return <Section>
        <FormsManager forms={selectedForms}
                      itemEditing={itemEditing}
                      selectedFormType={selectedFormType}
                      onItemEditingChange={onItemEditingChange}
                      open={open}
                      onOpenChanged={onOpenChanged}
                      dataListHeader={selectedDataListHeader}/>
        <ModalPopUp open={open} onOpenChanged={onOpenChanged}
                    modalContent={<ModalEditItem open={open}
                                                 selectedFormType={selectedFormType}
                                                 itemEditing={itemEditing}
                                                 onItemEditingChanged={onItemEditingChange}
                                                 onOpenChanged={onOpenChanged}/>}/>
    </Section>
}

function FormsManager(props) {
    const {forms, dataListHeader, selectedFormType, onOpenChanged, open, onItemEditingChange} = props;
    return <DataListView onOpenChange={() => onOpenChanged(!open)}
                         title={selectedFormType}
                         onItemEditChange={onItemEditingChange}
                         header={dataListHeader}
                         searchHeaders={[...dataListHeader, {title: 'verwerkt', fieldName: 'verwerkt',isBool: true, default: false}]}
                         dataArray={forms}/>

}

function ModalEditItem(props) {
    const {onItemEditingChanged, onOpenChanged, itemEditing, selectedFormType} = props;
    const formForEditing = useCallback(() => {
        switch (selectedFormType) {
            case 'amodels': {
                return <AmodelForm itemEditing={itemEditing} onOpenChanged={onOpenChanged}
                                   onItemEditingChanged={onItemEditingChanged}/>
            }
            case 'bmodels': {
                return <BmodelForm itemEditing={itemEditing} onOpenChanged={onOpenChanged}
                                   onItemEditingChanged={onItemEditingChanged}/>
            }
            case 'cmodels': {
                return <CmodelForm itemEditing={itemEditing} onOpenChanged={onOpenChanged}
                                   onItemEditingChanged={onItemEditingChanged}/>
            }
            case 'dmodels': {
                return <DmodelForm itemEditing={itemEditing} onOpenChanged={onOpenChanged}
                                   onItemEditingChanged={onItemEditingChanged}/>
            }
            case 'occacti': {
                return <OccActimodelForm itemEditing={itemEditing} onOpenChanged={onOpenChanged}
                                         onItemEditingChanged={onItemEditingChanged}/>
            }
        }
    });
    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={onItemEditingChanged}>
        <Section>
            {formForEditing()}
        </Section>
    </ModalContentContainer>
}

